let expressApi = {
  name: "查询快递列表",
  updateTime: "2020-05-30 10:00:00",
  methods: 'post',
  url: 'ygw.api.shipper.list',
  request: [{
    params: 'provinceCode',
    type: "String",
    required: true,
    length: '',
    description: {
      text: '查询快递列表的省编码（全国统一）',
      value: []
    },
    example: '浙江省 330000'
  }],
  reseponse: [{
    params: 'shipperCode',
    type: "String",
    required: true,
    length: '',
    description: {
      text: '快递编码',
      value: []
    },
    example: 'XSR'
  }, {
    params: 'shipperName',
    type: "String",
    required: true,
    length: '',
    description: {
      text: '快递名称',
      value: []
    },
    example: '速尔快递'
  }, {
    params: 'default',
    type: "Boolean",
    required: true,
    length: '',
    description: {
      text: '是否默认快递',
      value: []
    },
    example: 'True'
  }],
  code: {
    sign: "94c0d23036d9ef73c551c8c49497d802",
    appId: "9527",
    method: "ygw.api.order.create",
    params: JSON.stringify({
      context: {
        provinceCode: 330000
      }
    })
  }
}

export default expressApi;